enum ButtonVariantEnum {
  'primary' = 'primary',
  'secondary' = 'secondary',
  'success' = 'success',
  'danger' = 'danger',
  'warning' = 'warning',
  'info' = 'info',
  'dark' = 'dark',
  'purple' = 'purple',
  'pink' = 'pink',
  'light' = 'light',
  'link' = 'link',
  'default' = 'default', // 金流 UI 新增
  'primary-line' = 'primary-line', // 金流 UI 新增
  'icon' = 'icon', // 金流 UI 新增
  // outline
  'outline-primary' = 'outline-primary',
  'outline-secondary' = 'outline-secondary',
  'outline-success' = 'outline-success',
  'outline-danger' = 'outline-danger',
  'outline-warning' = 'outline-warning',
  'outline-info' = 'outline-info',
  'outline-dark' = 'outline-dark',
  'outline-purple' = 'outline-purple',
  'outline-pink' = 'outline-pink',
  'outline-light' = 'outline-light',
  // soft
  'soft-primary' = 'soft-primary',
  'soft-secondary' = 'soft-secondary',
  'soft-success' = 'soft-success',
  'soft-danger' = 'soft-danger',
  'soft-warning' = 'soft-warning',
  'soft-info' = 'soft-info',
  'soft-dark' = 'soft-dark',
  'soft-purple' = 'soft-purple',
  'soft-pink' = 'soft-pink',
  // bordered
  'bordered-primary' = 'bordered-primary',
  'bordered-secondary' = 'bordered-secondary',
  'bordered-success' = 'bordered-success',
  'bordered-danger' = 'bordered-danger',
  'bordered-warning' = 'bordered-warning',
  'bordered-info' = 'bordered-info',
  'bordered-dark' = 'bordered-dark',
  'bordered-purple' = 'bordered-purple',
  'bordered-pink' = 'bordered-pink',
  'none' = 'none',
}

export default ButtonVariantEnum;
